import { Component, OnInit, Inject, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { Entity } from 'src/app/models/entities.model';
import { PermissionService } from 'src/app/features/permissions/services/permission.service';
import { EntityValidatorService, EntityValidationData, UserPermission } from '../../services/entity-validator.service';
import { Relation } from 'src/app/models/relations.model';
import { Document } from 'src/app/features/documents/models/document.models';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { ValidationFields, ValidationRejection, EntityValidation, ValidationAprovalRequest } from '../../models/entity-validation.model';
import { FormHelper } from 'src/app/core/helpers/form.helpers';
import { UtilService } from 'src/app/core/services/util.service';
import { EntityService } from '../../services/entity.service';
import { Alert } from 'src/app/models/alerts.model';
import { EntityValidators } from 'src/app/core/validators/entity.validators';
import { EntityValidationViewComponent } from '../entity-validation-view/entity-validation-view.component';
import { StorageService } from 'src/app/core/services/storage.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ValidationConfirmationComponent } from './validation-confirmation/validation-confirmation.component';
import { EntityValidatorResponse, EntityValidatorData } from './entity-validator.models';
import { ImageViewAdvancedComponent } from 'src/app/features/images/components/image-view-advanced/image-view-advanced.component';


@Component({
  selector: 'gio-entity-validator',
  templateUrl: './entity-validator.component.html',
  styleUrls: ['./entity-validator.component.scss']
})
export class EntityValidatorComponent implements OnInit {

  @ViewChild('documentImage')
  imageRef: ImageViewAdvancedComponent;

  permissions = {
    validate_entities: false,
    validate_athletes: false,
    validate_referees: false,
    validate_contributors: false,
    validate_clubs: false,
    validate_leagues: false,
    validate_users: false
  };
  isValidator = false;

  loading = 'Iniciando...';
  error = '';

  entityData: EntityValidationData;

  entity: Entity;
  documents: Document[];
  relations: Relation[];
  users: UserPermission[];
  history: EntityValidation[];

  document: Document;
  profileImage: Entity;
  previewURL: SafeResourceUrl;

  fieldsMessages = {
    photo_url: 'A Foto de perfil enviada ',
    name: 'O seu nome ',
    document: 'O CPF informado no seu cadastro ',
    rg: 'O RG informado no seu cadastro ',
    document_foreigner : 'O registro do exterior informado no seu cadastro',
    birth: 'A Sua data de nascimento '
  };


  formRejection = this.fb.group({
    reason: ['']
  });

  validateds: ValidationFields = {
    photo_url: false,
    name: false,
    document: false,
    document_foreigner: false,
    birth: false,
  };

  messages: ValidationRejection[] = [];
  rejecting: ValidationRejection;
  validatedDocuments: number[] = [];

  showAlert = false;


  form = this.fb.group({
    name: ['', Validators.required],
    email: [],
    is_company: [false],
    birth: ['', Validators.required],
    validation_expires: []
  });

  formAlert = this.fb.group({
    message: ['']
  });

  image: File;

  canValidate = false;

  constructor(
    public dialogRef: MatDialogRef<EntityValidatorComponent, EntityValidatorResponse>,
    @Inject(MAT_DIALOG_DATA) public data: EntityValidatorData,
    private sPermission: PermissionService,
    private service: EntityValidatorService,
    private fb: FormBuilder,
    private util: UtilService,
    private sEntity: EntityService,
    private modal: MatDialog,
    private sStorage: StorageService,
    private sanitizer: DomSanitizer,

  ) { }

  ngOnInit() {
    const context = this.sEntity.context;

    if (context.source_name === 'users') {
      // must have internal permission to validate on behalf 4bp
      this.sPermission.setInternalPermissions(this.permissions);
    } else if (this.sEntity.context.source_name === 'leagues') {
      // entities must be validated only by leagues
      this.sPermission.setPermissions(this.permissions);
    }
    this.loadData();
  }

  async loadData() {
    try {
      this.loading = 'Buscando cadastro';
      if (this.data.entity_name) {
        this.loading += ` de ${this.data.entity_name}`;
      }

      this.error = '';
      const res = await this.service.getEntityData(this.data.entity_id).toPromise()
      this.loading = '';
      this.entityData = res;
      if (res.history && res.history.length > 0) {
        const histories = res.history.sort((a, b) => a.id > b.id ? -1 : 1);
        Object.assign(this.validateds, histories[0].validated_data);
      }

      this.entity = this.entityData.entity;
      this.documents = this.entityData.documents;
      this.relations = this.entityData.relations;
      this.users = this.entityData.permissions;
      this.history = this.entityData.history;

      if (this.entity.source_name === 'athletes') {
        this.validateds.rg = false;
      }
      this.appendFields();
      this.form.patchValue(this.entity);


      this.isValidator = this.permissions['validate_' + this.entity.source_name];

      if (!this.entity.validated && this.isValidator) {
        if (this.documents && this.documents.length > 0) {
          this.openDocument(this.documents[0]);
        }
      }
      this.updatePermissions();


    } catch (err) {

      this.loading = '';
      this.error = 'Não foi possível retornar os dados cadastrais desta entidade!';

    }

  }

  updatePermissions() {
    this.sPermission.setPermissions(this.permissions);

    if (this.entityData && this.entityData.entity) {
      const entity = this.entityData.entity;
      if (entity.source_name == 'athletes') {
        this.canValidate = this.permissions.validate_athletes;
      } else if (entity.source_name == 'clubs') {
        this.canValidate = this.permissions.validate_clubs;
      }
      else if (entity.source_name == 'contributors') {
        this.canValidate = this.permissions.validate_contributors;
      }
      else if (entity.source_name == 'referees') {
        this.canValidate = this.permissions.validate_referees;
      }
      else if (entity.source_name == 'users') {
        this.canValidate = this.permissions.validate_users;
      }
      else if (entity.source_name == 'leagues') {
        this.canValidate = this.permissions.validate_leagues;
      }
    }

  }

  appendFields() {
    if (['athletes', 'users'].includes(this.entity.source_name) || (['athletes'].includes(this.entity.source_name)) && !this.entity.foreigner) {
      this.form.addControl('rg', new FormControl(''));
    }

    if (['athletes', 'users', 'contributors', 'referees'].includes(this.entity.source_name) ||( ['athletes'].includes(this.entity.source_name) && !this.entity.foreigner)) {
      this.form.addControl('document', new FormControl('', [Validators.required, EntityValidators.isCPF]));
    }
    if (['leagues', 'clubs'].includes(this.entity.source_name)) {
      this.form.addControl('document', new FormControl('', [Validators.required, EntityValidators.isCNPJ]));
    }

    if(['athletes'].includes(this.entity.source_name) && this.entity.foreigner){
      this.form.addControl('document_foreigner', new FormControl(''));
    }
  }

  getEntityRG() {
    if (this.entityData && this.entityData.entity) {
      if (['users', 'athletes', 'contrubutors'].includes(this.entityData.entity.source_name)) {
        return (this.entityData.entity as any).rg;
      }
    }
    return '';
  }

  async openDocument(document: Document) {
    const path = await this.sStorage.getPublicURL(document.path);
    this.previewURL = this.sanitizer.bypassSecurityTrustResourceUrl(path);
    this.document = document;

  }

  isFieldRejected(fieldName: string) {
    return this.messages.find(r => r.type == 'F' && r.field === fieldName);
  }

  isFieldAproved(fieldName: string) {
    return this.validateds[fieldName];
  }

  isDocumentProved(document: Document) {
    return this.validatedDocuments.includes(+document.id);
  }

  isDocumentRejected(document) {
    if (this.messages && this.messages.length > 0) {
      return !!this.messages.find(message => message.type === 'D' && +message.target_id === +document.id);
    }
    return false;
  }

  aproveField(fieldName: string) {
    this.validateds[fieldName] = true;
    if (fieldName === 'photo_url') {
      this.profileImage = null;
    }

  }

  rejectField(fieldName: string, reason?: string) {
    if (fieldName === 'photo_url') {
      this.profileImage = null;
      this.validateds.photo_url = false;
    }
    this.rejecting = {
      field: fieldName,
      type: 'F',
      reason: `${this.fieldsMessages[fieldName]} não pode ser validado com os documentos apresentados.`
    };
    this.formRejection.patchValue({ reason: this.rejecting.reason });
  }

  rejectDocument(document: Document, reason?: string) {
    const message: ValidationRejection = {
      type: 'D',
      reason: `O ${document.document_type.name} enviado foi rejeitado e excluido `,
      target_id: +document.id
    };

    this.formRejection.patchValue({ reason: message.reason });
    this.document = null;

    this.rejecting = message;
  }

  aproveDocument(document: Document) {
    if (!this.validatedDocuments.includes(+document.id)) {
      this.validatedDocuments.push(+document.id);
    }
    this.document = null;
  }

  appendRejection() {
    const reason = this.formRejection.value.reason;
    this.rejecting.reason = reason;
    this.messages.push(this.rejecting);
    if (this.rejecting.type === 'D') {
      this.document = null;
    }
    this.rejecting = null;

    this.profileImage = null;
  }

  close(result?: EntityValidatorResponse) {
    this.dialogRef.close(result);
  }

  async save() {
    const _baseYear =  new Date().getFullYear();
    if((_baseYear - new Date(this.form.value.birth).getFullYear()) > 99){
      this.util.dialog.inform('A idade é maior que 99 anos, verificar idade se esta de acordo com o documento.', 'atenção');
      return;
    }


    try {
      if (!this.validate()) {
        return;
      }
      const updates: Partial<Entity> = FormHelper.getChangedValues(this.entityData.entity, this.form.value, false);

      const dataToSave: ValidationAprovalRequest = {
        validationType: 'aprove',
        fieldsToUpdate: updates,
        validatedDocuments: this.validatedDocuments,
        validatedFields: this.validateds,
        rejections: this.messages
      };

      let m = '';
      const documentsToReject = this.messages.filter(_m => _m.type === 'D');
      if (documentsToReject && documentsToReject.length > 0) {
        m += `<br/>Os ${documentsToReject.length} documentos rejeitados serão <b>excluidos</b>.`;
      }

      const confirmation = this.modal.open(ValidationConfirmationComponent, {
        width: '600px',
        maxWidth: '90%',
        closeOnNavigation: true,
        maxHeight: '90vh',
        height: 'auto',
        data: {
          entity: this.entity,
          dataToSave
        }
      });

      confirmation.afterClosed().subscribe(async result => {
        if (result) {
          if (result.message) {
            dataToSave.message = result.message;
          }

          this.util.loader.show(`Aprovando perfil de ${this.entity.name}`);
          this.service.aprove(this.entity.id, dataToSave)
            .subscribe(
              res => {
                this.util.loader.close();
                this.dialogRef.close({
                  status: 'aproved',
                  data: res
                });
              },
              err => {
                this.util.loader.close();
              }
            );

        }

      });


    } catch (error) {
      console.error('error saving validation', error);
    }

  }

  async sendRejections() {

    const dispatch = async () => {
      const messages = '"' + this.messages.map(m => m.reason).join('" <br />"') + '"';

      const docsToExclude = this.messages.filter(m => m.type === 'D');
      let docMessage = '';
      if (docsToExclude && docsToExclude.length > 0) {
        docMessage += `, ${docsToExclude.length} documentos serão excluidos`;
      }
      const confirm = await this.util.dialog.confirm(`As seguintes rejeições serão enviadas${docMessage}
        e o cadastro desta entidade ficará marcado como não validado.<br />
        ${messages}
      `, 'Rejeitar cadastro');

      if (confirm) {
        this.util.loader.show('Rejeitando...');
        this.service.reject(this.entity.id, this.messages)
          .subscribe(
            res => {
              this.util.loader.close();
              this.dialogRef.close({
                status: 'rejected',
                data: res
              });
            },
            err => {
              this.util.loader.close();
            });
      }
    };

    if (!this.messages || this.messages.length == 0) {

      const dataToSave: ValidationAprovalRequest = {
        validationType: 'reject',
        fieldsToUpdate: null,
        validatedDocuments: null,
        validatedFields: null,
        rejections: this.messages
      };

      let m = '';
      const documentsToReject = this.messages.filter(_m => _m.type === 'D');
      if (documentsToReject && documentsToReject.length > 0) {
        m += `<br/>Os ${documentsToReject.length} documentos rejeitados serão <b>excluidos</b>.`;
      }

      const confirmation = this.modal.open(ValidationConfirmationComponent, {
        width: '600px',
        maxWidth: '90%',
        closeOnNavigation: true,
        maxHeight: '90vh',
        height: 'auto',
        data: {
          entity: this.entity,
          dataToSave
        }
      });

      confirmation.afterClosed().subscribe(async result => {
        if (result) {
          if (result.message) {
            this.messages.push({
              reason: result.message,
              type: 'M'
            });
            dispatch();
          }
        }
      });

      return;
    }

    dispatch();



  }

  validate() {

    // verify if an document is validated

    let validated = false;
    if (this.validatedDocuments && this.validatedDocuments.length > 0) {
      validated = true;
    }

    if (!validated) {
      this.util.toast.info(`É necessário que ao menos 1 documento seja validado para ser utilizado como base de comparação!`, {
        timer: 80
      });
      return;
    }
    
    // verify fields
    const fields = Object.keys(this.validateds);
    validated = true;

    const unvalidateds = [];
    fields.forEach(field => {
      if (!this.validateds[field]) {

        if((field === 'rg' || field === 'document') && this.entity.foreigner  ){
          return;
        }

        if(field === 'document_foreigner' && ( !this.entity.foreigner && ['referees', 'athletes', 'contributors'].includes(this.entity.source_name))){
          return;
        }

        if (field === 'rg' && this.entity.source_name === 'referees') {
          return;
        }
        validated = false;
        
        unvalidateds.push(this.fieldsMessages[field]);
      }
    });

    if (!validated) {
      this.util.toast.error(`Os campos abaixo precisam ser verificados para que este cadastro seja validado: <br><br>
      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<b>*${unvalidateds.join('<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;*')}</b>
      `);
      return false;
    }

    // not avaliated documents
    const notAvaliated = this.documents.filter(document => {
      if (document.validated) {
        return false;
      }

      if (this.messages.find(m => +m.target_id === +document.id)) {
        return false;
      }

      if (this.validatedDocuments.find(d => +d === +document.id)) {
        return false;
      }
      return true;
    });

    if (notAvaliated && notAvaliated.length > 0) {
      this.util.toast.error(`Todos os documentos precisam estar aprovados ou rejeitados!`);
      return false;
    }


    return true;
  }

  showAlertBox() {
    this.formAlert.patchValue({
      // tslint:disable-next-line: max-line-length
      message: `Para podermos validar o seu cadastro, precisamos que você acesse o menu documentos e envie o seu CPF, RG ou certidão de nascimento!`
    });
    this.showAlert = true;
  }

  sendAlert() {
    const data = this.formAlert.value;

    const alert = new Alert({
      alert_type: 'DIRECT_MESSAGE',
      description: data.message,
      action_link: '_home/{source_name}/documents',
      source_entity: +this.sEntity.context.id,
      target_entity: +this.entity.id,
      source_entity_photo_path: this.sEntity.context.photo_url,
      title: 'Oi! '
    });

    this.util.loader.show(`Enviando mensagem...`);
    this.sEntity.sendAlert(this.entity.id, alert)
      .subscribe(
        res => {
          this.util.loader.close();
          this.showAlert = false;
          this.util.toast.success(`Mensagem enviada!`);
        },
        err => {
          this.util.loader.close();
        }
      );
  }

  showValidation(validation: EntityValidation) {
    this.modal.open(EntityValidationViewComponent, {
      width: '800px',
      maxWidth: '90vw',
      height: '800px',
      maxHeight: '90vh',
      data: { validation }
    });
  }

}
